import { Header as PritiHeader } from "../design/priti/components/header/Header";
import { Footer as PritiFooter } from "../design/priti/components/footer/Footer";

/* import { Header as JudgesHeader } from "../design/judges/components/header/Header";
import { Footer as JudgesFooter } from "../design/judges/components/footer/Footer"; */

import { Box, Container } from "@mui/material";
import { SecWelcome } from "../design/priti/sections/SecWelcome";
import { SecAbout } from "../design/priti/sections/SecAbout";
import { SecSkills } from "../design/priti/sections/SecSkills/SecSkills";
import { SecProjects } from "../design/priti/sections/SecProjects/SecProjects";
import { SecExperience } from "../design/priti/sections/SecExperience/SecExperience";
import { SecLanguages } from "../design/priti/sections/SecLanguages/SecLanguages";
import { SecContactMe } from "../design/priti/sections/SecContactMe/SecContactMe";
import { experienceList } from "../data/experienceList";
import { educationList } from "../data/educationList";
/* import { useContext } from "react";
import { DesignContext } from "../context/DesignContext"; */

const Scope = ({ children }: any) => {
  return (
    <>
      <Container
        fixed
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: "var(--c-bg-content-color)",
            width: "100%",
            marginTop: { xs: 2, md: "50px" },
            borderRadius: "24px",
            boxShadow:
              "inset 5px 5px 10px var(--c-box-shadow-color-2), inset -5px -5px 10px var(--c-box-shadow-color-1)",
          }}
        >
          {children}
        </Box>
      </Container>
    </>
  );
};
export const Content = () => {
  //const { design, setDesign } = useContext(DesignContext);
/*   const switchDesign = () => {
    setDesign((prev) => (prev === "priti" ? "judges" : "priti"));
  }; */
  return (
    <>
     {/*  <Box sx={{ color: "red" }}>
        <p>Current design: {design}</p>
        <button onClick={switchDesign}>Switch Design</button>
      </Box> */}

      {/* {design === "priti" ? ( */}
        <>
          <Scope>
            <PritiHeader />
            <SecWelcome />
            <SecAbout />
            <SecSkills />
            <SecExperience items={experienceList} type="experience" />
            <SecProjects />
            <SecExperience items={educationList} type="education" />
            <SecLanguages />
          </Scope>
          <Container
            fixed
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <SecContactMe />
            </Box>
          </Container>
          <PritiFooter />
        </>
      {/* ) : (
        <>
          <JudgesHeader />
          <JudgesFooter />
        </>
      )} */}
    </>
  );
};

export default Content;
